import React, { useEffect, useState } from "react";
import Css from './Mockup.module.css'
import { useParams } from "react-router-dom";
import { Link, useNavigate} from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import LayoutLandingPage from "components/layout/LayoutLandingPageV3";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { ConvertDateToText} from "components/MyControl";
import { Breadcrumb } from "react-bootstrap";
import { Helmet } from 'react-helmet-async';

export default function ArticleDetail(){
  const nav = useNavigate();
  const { title } = useParams();
  const api = new ApiConection();
  const [articleDetail, setArticleDetail] = useState({});
  const [photo, setPhoto] = useState(undefined);

  const getArticleDetail = async () => {
    const response = await api.callLandingPageGet(`api/BlogManagement/title/${encodeURIComponent(title.replaceAll('_',' '))}`);
    if (response.status === true) {
        const response_photo = await getSlipFile(response.data.image_id);
        const imageUrl = (response_photo !== undefined) ? URL.createObjectURL(response_photo) : undefined;
        
        setArticleDetail({ ...response.data, imageUrl });
    }
};

  const getSlipFile = async (id) => {
    if (id !== null && id !== undefined) {
        return await api.callLandingPageGetFile(`api/file/${id}/preview`);
    } else {
        return undefined;
    }
  }
  const handleBreadcrumbClick = (e) => {
    nav('/article');
  };

  useEffect(() => {
    getArticleDetail();
  }, [title]);

  const ArticlePage = ({articleDetail})=> {
    return (
      <>
        <Helmet>
            <title>{`${articleDetail?.title} | ISO DCaaS`}</title>
            <meta name="description" content={articleDetail?.description} />
            <meta name="author" content={articleDetail?.written_by} />
            <meta name="keywords" content={`ISO DCaaS, ISO, DCaaS,${articleDetail?.title}`} />
            <meta property="og:title" content={`${articleDetail?.title} | ISO DCaaS`} />
            <meta property="og:description" content={articleDetail?.description} />
            <meta property="og:url" content={window.location?.href} />
            <meta property="og:image" content={articleDetail?.imageUrl} />
            <meta name="twitter:card" content={articleDetail?.title} />
            <meta name="twitter:title" content={`${articleDetail?.title} | ISO DCaaS`} />
            <meta name="twitter:description" content={articleDetail?.description} />
            <meta name="twitter:image" content={articleDetail?.imageUrl} />
        </Helmet>
      </>
    );
  }

  return (
    <>
        
        <LayoutLandingPage showContactUs={false}>
        <ArticlePage articleDetail={articleDetail} />
            <div className={`${Css.outline_layout} container m-auto`}>
                <h2 className="" >บทความ</h2>
                <Breadcrumb>
                    <Breadcrumb.Item onClick={handleBreadcrumbClick}>บทความ</Breadcrumb.Item>
                        <Breadcrumb.Item active style={{ whiteSpace: 'nowrap' }}>
                            {
                                <div>{articleDetail.title}</div>
                            }
                        </Breadcrumb.Item>
                </Breadcrumb>

                <div className="container text-center mt-5">
                    <div className={`text-center`}>
                    <h1 >{articleDetail.title}</h1>
                    </div>
                    {articleDetail?.imageUrl !== undefined && (
                        <img
                            src={articleDetail?.imageUrl}
                            width="100%"
                            alt="Article Image"
                            className="mt-5 mb-5"
                        />
                    )}
                </div>
                <div className="col">   
                    <div id="article_id" style={{ padding: '20px'}}  dangerouslySetInnerHTML={{ __html: articleDetail?.blog_body?.replace(/  /gi,'&nbsp;') }} />
                </div>
                <div className="pt-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <p className="card-text"><small className="text-muted">เขียนโดย : {articleDetail.written_by}</small></p>
                    <p className="card-text" style={{ marginTop: '-15px' }}><small className="text-muted"><FontAwesomeIcon icon={faClock} /> {ConvertDateToText(articleDetail.release_date)}</small></p>
                </div>
            </div>
        </LayoutLandingPage>
    </>

  );
};